import { extendTheme } from '@chakra-ui/react';
import { colors } from './constants';

import Alert from '@/components/DataDisplay/Alert/styleConfig';

import {
  BodyStyleConfig as Body,
  CaptionStyleConfig as Caption,
  FootnoteStyleConfig as Footnote,
  HeadingStyleConfig as Heading,
  HeadlineStyleConfig as Headline,
  ParagraphStyleConfig as Paragraph,
  TextButtonStyleConfig as TextButton,
  TextStyleConfig as Text,
} from '@/components/Typography';

import { CheckboxStyleConfig as Checkbox } from '@/components/Form/Checkbox/styleConfig';

const theme = extendTheme({
  components: {
    Heading,
    Caption,
    TextButton,
    Paragraph,
    Body,
    Footnote,
    Headline,
    CustomText: Text,
    CustomAlert: Alert,
    Checkbox,
  },
  fonts: {
    lato: 'Lato, sans-serif',
    body: 'Lato, sans-serif',
  },
  colors,
});

export default theme;
